import {ErrorHandler, Injectable, Injector, NgZone} from '@angular/core';
import {UIService} from "./ui.service";
import {Router} from "@angular/router";

export interface GlobalError {
  code: number;
  message: string;
  stacktrace?: string;
}

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {

  constructor(private ui: UIService, private injector: Injector) {
    super();
  }

  convert(rawError: any): GlobalError {
    const error = rawError.rejection || rawError;
    return {
      code: error.status ?? -1,
      message: error.message || 'Undefined client error',
    };
  }

  override handleError = (error: any): void => {
    super.handleError(error);
    let router = this.injector.get(Router);
    const ge = this.convert(error);
    // TODO - if HTTP Response Error + 401, 403, route to unauth
    if([401, 403].includes(ge.code)){
      router.navigate(['/unauth']).then();
    }
    this.injector.get(NgZone).run(() => {
      this.ui.error$.next(ge);
    });
  };
}
